import { useMediaQuery, useTheme } from '@mui/material';

import { Header } from '../../layout-primary/header';
import { useStyles } from './facts-about-brand.styles';
import brandComfort from '../../../../../assets/images/brand-pages/facts-about-brand/brand-comfort.png';
import { Footer } from '../../../../common/footer';
import brandComfortMobile from '../../../../../assets/images/brand-pages/facts-about-brand/brand-comfort-mobile.png';

export const BrandComfort = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      {isMobile && <Header />}
      <section className={classes.root} data-testid="winners-content">
        <img src={isMobile ? brandComfortMobile : brandComfort} width={422} height={551} alt="" />
      </section>
      {isMobile && <Footer />}
    </>
  );
};
